import ImageCard from 'components/cards/base/ImageCard'
import Strings from 'project/localisation'
import { ReactFC } from 'common/types/ReactFC'
import React from 'react'
import { planPerksStrings } from 'common/strings/plan-perks-strings' // we need this to make JSX compile

type PlanPerksCardType = {}

function perks() {
  return [
    {
      description:
        'Use 86-90 Paul Street, London, EC2A 4NE  as your company’s official registered office address with Companies House.',
      title: 'A low-cost virtual London Address.',
    },
    {
      description:
        'We scan and send your mail to your inbox, the mobile app, and customer portal within one business day.',
      title: 'Mail services straight to your inbox within 1 day.',
    },
    {
      description:
        'HaiRo™ provides you with mail summaries, category tags, and key details from your correspondence.  Once we receive a new mail item, HaiRo™ notifies you and your team, so you never miss important business mail.',
      title: 'AI-powered mail handling services to streamline your business.',
    },
    {
      description:
        'Our state-of-the-art technology digitises and organises your physical mail, making every mail item fully searchable. Mail management made easy.',
      title: 'Digitised and organised.',
    },
    {
      description:
        'Never lose a document again — over 1 million pieces of mail processed to date. 60,000+ businesses managed and growing.',
      title: 'Always safe and secure.',
    },
    {
      description:
        'Simple price plan for your virtual office address and mail services provided by HaiRo™.',
      title: 'One plan, 10-minute setup, monthly cancellation.',
    },
    {
      description:
        'We automatically filter out junk mail, ensuring you only receive the important communications that matter to your business. Spend less time sorting and more time focusing on what’s essential.',
      title: 'Built-in Junk Mail Filter.',
    },
  ]
}
const PlanPerksCard: ReactFC<PlanPerksCardType> = ({}) => {
  return (
    <ImageCard
      shadow={false}
      reverseColumnsMobile
      verticalAlign='center'
      padding='0'
      imageAlt={`${Strings.companyFormation}`}
      imageLeft
      image='/images/new/cool-robot-holding-phone.png'
      imageDimensions={{
        height: 839,
        width: 616,
      }}
      classNameForCol1='col-lg-12 col-xxl-6 pe-xxl-14 px-6'
      classNameForCol2='col-lg-6 offset-xxl-0 offset-lg-3 col-xl-6 ps-xxl-18'
    >
      <p className='fw-semibold fs-fluid-24-32 mb-4'>
        {Strings.signupIncludes}
      </p>
      {perks().map((v) => (
        <>
          <p className='text-large fw-bold mb-2'>{v.title}</p>
          <p
            className='text-large fw-semibold mb-6 text-muted'
            dangerouslySetInnerHTML={{ __html: v.description }}
          />
        </>
      ))}
    </ImageCard>
  )
}

export default PlanPerksCard
